import { lazy } from "react";
import {usrPermission} from "../../config/userPermission";

const DesignerView = lazy(() => import("./pages/./DesignerView"));

export const routes: any = [
    {
        path: "gallery",
        permission: usrPermission.designer.r,
        element: <DesignerView />,
    },
];
